import React, { useState } from 'react';
import { Modal, Row, FormGroup, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { isEmpty, flatMap } from 'lodash';
import { MultiSelect } from 'react-multi-select-component';
import { fetchDamList } from '../../Pages/DAM/store/DAM.action';
import { Page_Size as pageSize } from '../helper';

function AssetGroupModal({
  options,
  selectedFolders,
  handleAssetChange,
  onOpen,
  onConfirm,
  toggle,
  selectedIds,
  selectedFileId,
  isFileProductLevel,
  damProductName,
  handleSave,
  selectedFilesData,
}) {
  const { t } = useTranslation('common');
  const [refCode, setrefCode] = useState(damProductName);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const newOptions = options.map((option) => {
    return {
      label: option.name,
      value: option._id,
    };
  });
  const onAddClick = async () => {
    const arrayOfArrayAssignedTo = selectedFilesData?.map((vl) => vl.assignedTo);
    const productTypeAssignedArray = arrayOfArrayAssignedTo?.map((subArray) => subArray?.map((item) => item?.supplierType));
    const brandTypeAssignedArray = arrayOfArrayAssignedTo.map((subArray) => subArray.map((item) => item.brandId));
    const ids = selectedFileId !== null ? [selectedFileId] : selectedIds;
    if (ids?.length > 0) {
      const params = {
        pageIndex: 1,
        pageSize,
      };
      await dispatch(fetchDamList(params));
      history.push('digital-assets-management/folder/add', {
        fileIds: ids,
        isFromDirectAssetModal: true,
        assetProductType: flatMap(productTypeAssignedArray),
        assetBrand: flatMap(brandTypeAssignedArray),
      });
    }
  };

  const handleChangedCode = ({ target }) => {
    setrefCode(target.value);
  };

  const postSubmitFunc = () => {
    setIsSubmitting(false);
  };

  const handleSubmit = () => {
    setIsSubmitting(true);
    const data = {
      referenceCode: refCode,
      postSubmitFunc,
    };
    handleSave(data);
  };

  return (
    <Modal show={onOpen} backdrop="static" className="custom-modal modal-small" aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">
            <span>{isFileProductLevel ? t('DAM_MAIN_VIEW.LISTING_VIEW.ADD_UPDATE_ASSET_LIBRARY') : t('DAM_MAIN_VIEW.LISTING_VIEW.ASSET_FOLDER')}</span>
          </Modal.Title>
          <span onClick={toggle} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-end">
          {isFileProductLevel ? (
            <Container fluid>
              <Row>
                <FormGroup className="w-100">
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      name="name"
                      placeholder={t('BOM_REFERENCE_MODAL.REFERENCE_CODE_LABEL')}
                      className="form-control"
                      value={refCode}
                      onChange={handleChangedCode}
                    />
                    <label className="asterisk-req">{t('BOM_REFERENCE_MODAL.REFERENCE_CODE_LABEL')}</label>
                  </div>
                </FormGroup>
              </Row>
            </Container>
          ) : (
            <>
              <div className="custom-react-select select-min-height flex-fill">
                <MultiSelect
                  name="group"
                  options={newOptions}
                  className="custom-multiselect"
                  value={newOptions.filter((val) => !isEmpty(selectedFolders) && selectedFolders?.includes(val?.value))}
                  labelledBy="Colour Groups"
                  onChange={(selected) => {
                    handleAssetChange(selected.map((val) => val.value));
                  }}
                />
              </div>
              <button type="button" onClick={onAddClick} className="btn btn-outline">
                <span className="icon icon-add" />
              </button>
            </>
          )}
        </div>
        <div className="modal-buttons mt-5 d-flex justify-content-between">
          <button disabled={isSubmitting} onClick={toggle} className="btn btn-default" type="button">
            {t('COMMON_LABEL.CANCEL')}
          </button>
          <button
            onClick={!isFileProductLevel ? onConfirm : handleSubmit}
            type="button"
            className="btn btn-default"
            disabled={isSubmitting || (!isFileProductLevel && !selectedFolders.length)}
          >
            {t('COMMON_LABEL.ADD')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AssetGroupModal;
